const state = {
    endpoint: process.env.VUE_APP_API_ENDPOINT,
    notification:{
      active: false,
      timeout: 5000,
      color: '',
      mode: '',
      text: ''
    },
    loading: false,
    miniSidebar: false,
    mobileSidebar: false,
    options_pagination:{
        page: 1,
        limit: 10
    },
}

const getters = {
    getLoading: state => {
        return state.loading
    },
    getEndpoint: state => {
        return state.endpoint
    },
    getNotification: state => {
        return state.notification
    },
    getMiniSidebar: state => {
        return state.miniSidebar
    },
    getMobileSidebar: state => {
        return state.mobileSidebar
    },
    getOptionsPagination: state => {
        return state.options_pagination
    }
}

const actions = {
}

const mutations = {
    setLoading: (state,value) => {
        state.loading = value
    },
    setMiniSidebar: (state,value) => {
        state.miniSidebar = value
    },
    setMobileSidebar: (state,value) => {
        state.mobileSidebar = value
    },
    setNotification: (state,value) => {
        state.notification ={
            active: value.active,
            timeout: 5000,
            color: value.color,
            mode: value.mode,
            text: value.text
        }
    },
    setOptionsPagination: (state,value) => {
        state.options_pagination = {
            page: value.page,
            limit: value.limit
        }
    }
}


export default {
    namespaced : true,
    state,
    mutations,
    getters,
    actions
}

